module.exports = __webpack_public_path__ + "media/alert.10737d28.mp3";